export default "__VITE_ASSET__e9284928__"